export default __webpack_public_path__ + "static/media/PH.e99264a2.svg";